const listeners = new Set();

export const ANALYSIS_TAB_LABEL = 'Analisis';
export const ANALYSIS_KIND_OPTION = 'option';
export const ANALYSIS_KIND_STOCK = 'stock';

export function openPortfolioAnalysis(payload) {
    const next = payload && typeof payload === 'object'
        ? payload
        : { kind: ANALYSIS_KIND_OPTION, id: payload };

    listeners.forEach((listener) => {
        try {
            listener(next);
        } catch (error) {
            console.error('[portfolioNav] openPortfolioAnalysis', error);
        }
    });
}

/** @deprecated use openPortfolioAnalysis */
export function openOptionAnalysis(optionId) {
    openPortfolioAnalysis({ kind: ANALYSIS_KIND_OPTION, id: optionId });
}

export function openStockAnalysis(stockId, symbol) {
    openPortfolioAnalysis({
        kind: ANALYSIS_KIND_STOCK,
        id: stockId,
        symbol,
    });
}

export function subscribePortfolioAnalysis(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

/** @deprecated use subscribePortfolioAnalysis */
export function subscribeOptionAnalysis(listener) {
    return subscribePortfolioAnalysis((payload) => {
        if (payload?.kind === ANALYSIS_KIND_STOCK) {
            listener(null);
            return;
        }
        listener(payload?.id ?? payload);
    });
}
